export const scrollDocumentToVet = () => {
  const vetSectionSelector = 'edit-form__delete-button';
  const anchor = document.querySelectorAll(vetSectionSelector);
  anchor.length > 0 && anchor[0].scrollIntoView(false);
};
